import { render, staticRenderFns } from "./JournalContent.vue?vue&type=template&id=ce254e62&scoped=true&"
import script from "./JournalContent.vue?vue&type=script&lang=js&"
export * from "./JournalContent.vue?vue&type=script&lang=js&"
import style0 from "./JournalContent.vue?vue&type=style&index=0&lang=less&"
import style1 from "./JournalContent.vue?vue&type=style&index=1&id=ce254e62&lang=less&scoped=true&"
import style2 from "./JournalContent.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce254e62",
  null
  
)

export default component.exports